import ModelService from "@/services/model.service";

import { getField, updateField } from 'vuex-map-fields';
export default {
  namespaced: true,
  state: () => ({
    models: [],
    key: "",
    offset: 1,
    total: 0,
  }),
  mutations: {
    SET_LIST_MODEL: (state, payload) => {
      state.models = payload;
    },
    SET_SEARCH_MODEL: (state, payload) => {
      state.key = payload;
    },
    SET_OFFSET_MODEL: (state, payload) => {
      state.offset = payload;
    },
    SET_TOTAL: (state, payload) => {
      state.total = payload;
    },
  },
  actions: {
    /**
     * Get list paging Model from username and paging it
     * @param {dict} param1 The dictionary contain `username`, `page` and `limit` 
     */
    async getList({ state, commit }, { username, page = 1, limit = 10 }) {

      let response = await ModelService.getListModel({ username, page, limit });
      if (response.status === 200) {
        const models = response.data?.models;
        commit("SET_TOTAL", response.data?.total_models);
        commit(
          "SET_LIST_MODEL",
          models.map((res, idx) => ({
            ...res,
            index: (state.offset - 1) * limit + idx + 1,
            status: res.status.toLowerCase(),
            id: res._id.$oid,
          }))
        );

      }
    },
    /**
     * @param {dict} payload The parameters dictionary contains 
     * `username`, `modelName` and `newModelName`
     */
    async renameModel({ state }, payload) {
      let response = await ModelService.renameModel(payload.modelId,
        {
          username: payload.username,
          model_name: payload.modelName,
          new_model_name: payload.newModelName
        }
      );
      
      return response.status
    },
    /**
     * Delete model
     * @param {dict} payload The dictionary contains `username`, `model_name` and `model_id`
     */
    async deleteModel({ commit }, payload) {
			await ModelService.delete(payload);
    },
    /**
     * Get information about users, who be shared from given model
     * @param {*} payload 
     * @returns 
     */
    async getSharedModelUser({ commit }, payload) {
			let ressponse = await ModelService.getSharedModelUser(payload);
			return ressponse.data;
    },
    /**
     * Delete shared model from id
     * @param {*} payload The dictionary contain `shared_id`
     * @returns 
     */
    deleteSharedModel({ commit }, payload) {
			return ModelService.deleteSharedModel(payload);
    },
    /**
     * Share model
     * @param {dict} payload The dictionary contain `allowShareData` and
     * `body` which is a dictionary  contain `model_name`, `request_user` and `receive_users`
     * @returns 
     */
    shareModel({ commit }, { body, allowShareData }) {
			return ModelService.share({ body, allowShareData });
    },
  },

  getters: {
    getField,
    getListModel: (state) => {
      if (!state.key) return state.models;
      return state.models.filter(
        ({ model_name, username }) =>
          model_name?.toLowerCase()?.includes(state.key?.toLowerCase()) ||
          username?.toLowerCase()?.includes(state.key?.toLowerCase())
      );
    },
    getSearchModel: (state) => {
      return state.key;
    },
    getOffsetModel: (state) => {
      return state.offset;
    },
    /**
     * Get data for model table 
     * @param {*} state 
     * @returns 
     */
    getTablePerPageModel: (state) => {
      let models = [];
      if (!state.key) models = state.models;
      else
        models = state.models.filter(
          ({ model_name, username }) =>
            model_name?.toLowerCase()?.includes(state.key?.toLowerCase()) ||
            username?.toLowerCase()?.includes(state.key?.toLowerCase())
        );

      return models;
    },
    getTotal: (state) => {
      return state.total
    },
  },

};
